import { render, staticRenderFns } from "./ApproveDialog.vue?vue&type=template&id=76e9e05e&scoped=true"
import script from "./ApproveDialog.vue?vue&type=script&lang=js"
export * from "./ApproveDialog.vue?vue&type=script&lang=js"
import style0 from "./ApproveDialog.vue?vue&type=style&index=0&id=76e9e05e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e9e05e",
  null
  
)

export default component.exports